<script>
import {
  mapState
} from "vuex";
import {
  menuItems
} from "./menu";

/**
 * Sidebar component
 */
export default {
  data () {
    return {
      menuItems: menuItems,
    };
  },
  computed: {
    ...mapState(["layout"]),
    // 獲取當前用戶資訊
    currentUser () {
      try {
        const userCookie = this.$root.common.getCookie("user");
        if (userCookie) {
          // 如果已經是物件，直接返回
          if (typeof userCookie === 'object') {
            return userCookie;
          }
          // 如果是字串，嘗試解析
          if (typeof userCookie === 'string') {
            return JSON.parse(userCookie);
          }
        }
      } catch (e) {
        console.error("解析用戶資訊失敗:", e);
      }
      return null;
    },
    // 檢查是否為總管理員
    isSuperAdmin () {
      if (!this.currentUser) return false;
      return this.currentUser.role === 'super_admin';
    },
    // 獲取用戶權限列表
    userPermissions () {
      if (!this.currentUser) return [];
      // 如果是總管理員，返回所有權限
      if (this.isSuperAdmin) {
        return ['add_game', 'view_records', 'manage_accounts'];
      }
      // 普通管理員返回實際權限列表
      return this.currentUser.permissions || [];
    },
    // 根據權限過濾選單
    filteredMenuItems () {
      if (!this.currentUser) {
        // 如果沒有用戶資訊，只顯示 Dashboard
        return menuItems.filter(item => item.id === 1);
      }

      const filtered = [];
      let lastTitleIndex = -1;

      menuItems.forEach((item, index) => {
        // Dashboard 永遠顯示
        if (item.id === 1) {
          filtered.push(item);
          return;
        }

        // 處理標題項目
        if (item.isTitle) {
          // 先檢查這個標題後面是否有可顯示的項目
          let hasVisibleChild = false;
          for (let i = index + 1; i < menuItems.length; i++) {
            const nextItem = menuItems[i];
            // 如果遇到下一個標題，停止檢查
            if (nextItem.isTitle) break;
            // 檢查這個項目是否可以顯示
            if (this.canShowMenuItem(nextItem)) {
              hasVisibleChild = true;
              break;
            }
          }
          // 如果有可顯示的子項目，則顯示標題
          if (hasVisibleChild) {
            filtered.push(item);
            lastTitleIndex = filtered.length - 1;
          }
          return;
        }

        // 處理一般選單項目
        if (this.canShowMenuItem(item)) {
          filtered.push(item);
        }
      });

      return filtered;
    }
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      required: true,
    },
    menu: {
      type: String,
      required: true,
    },
    topbar: {
      type: String,
      required: true,
    }
  },
  watch: {
    type: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "dark":
              // document.body.setAttribute("data-sidebar-color", "dark");
              break;
            case "light":
              // document.body.setAttribute("data-sidebar-color", "light");
              break;
            case "brand":
              // document.body.setAttribute("data-sidebar-color", "brand");
              break;
            case "gradient":
              // document.body.setAttribute("data-sidebar-color", "gradient");
              break;
            default:
              // document.body.setAttribute("data-sidebar-color", "light");
              break;
          }
        }
      },
    },
    width: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "boxed":
              // document.body.setAttribute("data-layout-width", "boxed");
              // document.body.setAttribute("data-sidebar-size", "condensed");
              break;
            case "fluid":
              // document.body.setAttribute("data-layout-width", "fluid");
              // document.body.removeAttribute("data-sidebar-size");
              // document.body.removeAttribute("data-layout-width");
              break;
            default:
              // document.body.setAttribute("data-layout-mode", "fluid");
              break;
          }
        }
      },
    },
    size: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "default":
              // document.body.setAttribute("data-sidebar-size", "default");
              break;
            case "condensed":
              // document.body.setAttribute("data-sidebar-size", "condensed");
              break;
            case "compact":
              // document.body.setAttribute("data-sidebar-size", "compact");
              break;
            default:
              // document.body.setAttribute("data-sidebar-size", "default");
              break;
          }
        }
      },
    },
    menu: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "fixed":
              // document.body.setAttribute("data-layout-menu-position", "fixed");
              break;
            case "scrollable":
              // document.body.setAttribute(
              //   "data-layout-menu-position",
              //     "scrollable"
              //                 );
              break;
            default:
              // document.body.setAttribute("data-layout-menu-position", "fixed");
              break;
          }
        }
      },
    },
    topbar: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "dark":
              // document.body.setAttribute("data-topbar-color", "dark");
              break;
            case "light":
              // document.body.setAttribute("data-topbar-color", "light");
              break;
            default:
              // document.body.setAttribute("data-topbar-color", "dark");
              break;
          }
        }
      },
    },
  },
  mounted: function () {
    this._activateMenuDropdown();
    this.$router.afterEach((routeTo, routeFrom) => {
      this._activateMenuDropdown();
    });
  },
  methods: {
    /**
     * 檢查選單項目是否可以顯示
     * @param {Object} item 選單項目
     * @returns {Boolean} 是否可以顯示
     */
    canShowMenuItem (item) {
      // 如果沒有權限要求，則顯示
      if (!item.permission) {
        return true;
      }

      // 如果是總管理員，顯示所有項目
      if (this.isSuperAdmin) {
        return true;
      }

      // 檢查用戶是否有對應權限
      return this.userPermissions.includes(item.permission);
    },
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems (item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },

    _activateMenuDropdown () {
      const resetParent = (el) => {
        el.classList.remove("active");
        var parent = el.parentElement;
        if (parent) {
          parent.classList.remove("menuitem-active");
          const parent2 = parent.parentElement;
          if (parent2) {
            const parent3 = parent2.parentElement;
            if (parent3) {
              parent3.classList.remove("show");
              const parent4 = parent3.parentElement;
              if (parent4) {
                parent4.classList.remove("menuitem-active");
              }
            }
          }
        }
      };
      var links = document.getElementsByClassName("side-nav-link-ref");
      var matchingMenuItem = null;
      const paths = [];
      for (let i = 0; i < links.length; i++) {
        // reset menu
        resetParent(links[i]);
      }
      for (var i = 0; i < links.length; i++) {
        paths.push(links[i]["pathname"]);
      }
      var itemIndex = paths.indexOf(window.location.pathname);
      if (itemIndex === -1) {
        const strIndex = window.location.pathname.lastIndexOf("/");
        const item = window.location.pathname.substr(0, strIndex).toString();
        matchingMenuItem = links[paths.indexOf(item)];
      } else {
        matchingMenuItem = links[itemIndex];
      }

      if (matchingMenuItem) {
        matchingMenuItem.classList.add("active");
        var parent = matchingMenuItem.parentElement;

        /**
         * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
         * We should come up with non hard coded approach
         */
        if (parent) {
          parent.classList.add("menuitem-active");
          const parent2 = parent.parentElement;
          if (parent2) {
            const parent3 = parent2.parentElement;
            if (parent3) {
              parent3.classList.add("show");
              const parent4 = parent3.parentElement;
              if (parent4) {
                parent4.classList.add("menuitem-active");
              }
            }
          }
        }
      }
    },
  },
};
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->
  <div class="left-side-menu">
    <!-- LOGO -->
    <div class="logo-box">
      <router-link to="/" class="logo logo-dark text-center">
        <span class="logo-sm">
          <img src="@/assets/images/logo-sm-dark.png" alt height="24" />
          <!-- <span class="logo-lg-text-light">Minton</span> -->
        </span>
        <span class="logo-lg">
          <img src="@/assets/images/logo-dark.png" alt height="20" />
          <!-- <span class="logo-lg-text-light">M</span> -->
        </span>
      </router-link>

      <router-link to="/" class="logo logo-light text-center">
        <span class="logo-sm">
          <!-- <img
            src="@/assets/images/logo-sm.png"
            alt
            height="24"
          /> -->
        </span>
        <span class="logo-lg logo-text">
          法語鸚鵡螺
        </span>
      </router-link>
    </div>

    <simplebar class="h-100" data-simplebar>
      <!--- Sidemenu -->
      <div id="sidebar-menu">
        <!-- Left Menu Start -->
        <ul class="list-unstyled" id="side-menu">
          <template v-for="item in filteredMenuItems">
            <li class="menu-title" v-if="item.isTitle" :key="item.id">{{ $t(item.label) }}</li>
            <li v-if="!item.isTitle && !item.isLayout" :key="item.id">
              <a v-if="hasItems(item)" href="javascript:void(0);" @click="item.isMenuCollapsed = !item.isMenuCollapsed"
                :class="{
                  'has-arrow': !item.badge,
                  'has-dropdown': item.badge
                }">
                <i :class="`${item.icon}`" v-if="item.icon"></i>
                <span>{{ $t(item.label) }}</span>
                <span class="menu-arrow" v-if="!item.badge"></span>
                <span :class="`badge badge-pill badge-${item.badge.variant} float-right`" v-if="item.badge">{{
                  $t(item.badge.text) }}</span>
              </a>

              <router-link :to="item.link" v-if="!hasItems(item)" class="side-nav-link-ref">
                <i :class="`${item.icon}`" v-if="item.icon"></i>
                <span>{{ $t(item.label) }}</span>
                <span :class="`badge badge-pill badge-${item.badge.variant} float-right`" v-if="item.badge">{{
                  $t(item.badge.text) }}</span>
              </router-link>
              <div class="collapse" :class="{ 'show': item.isMenuCollapsed }" id="sidebarTasks">
                <ul v-if="hasItems(item)" class="sub-menu nav-second-level" aria-expanded="false">
                  <li v-for="(subitem, index) of item.subItems" :key="index">
                    <router-link :to="subitem.link" v-if="!hasItems(subitem)" class="side-nav-link-ref">{{
                      $t(subitem.label) }}</router-link>
                    <a v-if="hasItems(subitem)" class="side-nav-link-a-ref has-arrow"
                      @click="subitem.isMenuCollapsed = !subitem.isMenuCollapsed" href="javascript:void(0);">{{
                        $t(subitem.label) }}
                      <span class="menu-arrow"></span>
                    </a>

                    <div class="collapse" :class="{ 'show': subitem.isMenuCollapsed }">
                      <ul v-if="hasItems(subitem)" class="sub-menu" aria-expanded="false">
                        <li v-for="(subSubitem, index) of subitem.subItems" :key="index">
                          <router-link :to="subSubitem.link" class="side-nav-link-ref">{{ $t(subSubitem.label)
                          }}</router-link>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </li>
          </template>
        </ul>
      </div>
      <!-- End Sidebar -->

      <div class="clearfix"></div>
    </simplebar>
    <!-- Sidebar -left -->
  </div>
  <!-- Left Sidebar End -->
</template>

<style lang="css" scoped>
.logo-text {
  color: #FFF;
  cursor: default;
  font-size: 1.2rem;
}
</style>